import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { companyService } from '../services/company.service';
import type { UpdateCompanyRequest, Company } from '../types/company.types';

export function useUpdateCompany(): {
  updateCompany: UseMutateFunction<Company, Error, { id: string; data: UpdateCompanyRequest }>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateCompanyRequest }) =>
      companyService.updateCompany(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['companies'] });
      queryClient.invalidateQueries({ queryKey: ['company', variables.id] });
    },
  });

  return {
    updateCompany: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
